import { initCategoriesSequence } from './sections/categories-sequence'
import { initSectionAnimations } from './section-animations'

$(document).ready(function (e){

  $('body').on('click', 'a.scroll-link', function (e) {
    e.preventDefault();
    const target = $(this).data('scroll-id');
    const $targetElement = $(target);
    if ($targetElement.length) {
        $('html, body').animate({
            scrollTop: $targetElement.offset().top
        });
    } else {
        const href = $(this).attr('href');
        if (href) {
            window.location.href = href;
        }
    }
});


  initCategoriesSequence()
  setTimeout(function (){
    initSectionAnimations()
  }, 200)

})
